import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import {
  factoryService,
  getFileRequest,
  getJsonRequest,
  postFormRequest,
  putJsonRequest
} from '@chilecompra/react-kit/requests'
import { features } from '../config/settings/features'

/**
 * Uploads the given a file, buyer.
 */
export const uploadFile = factoryService(({ file, quoteCode }) => {
  const body = { file, id: quoteCode }

  return postFormRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.attach'] ? 'compra-agil-adjuntos' : 'compra-agil'
    }/comprador/subir`,
    { body }
  )
})

/**
 * Get buyer attached files, buyer.
 */
export const getAttachedFiles = factoryService(({ quoteCode }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.attach'] ? 'compra-agil-adjuntos' : 'compra-agil'
    }/comprador/listar/${quoteCode}`
  )
})

/**
 * Get download file, buyer.
 */
export const getDowloadFile = factoryService(({ fileId }) => {
  return getFileRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.attach'] ? 'compra-agil-adjuntos' : 'compra-agil'
    }/comprador/descargar?id=${fileId}`
  )
})

/**
 * Delete a file by the given identifier, buyer.
 */
export const deleteFile = factoryService(({ fileId, ipUsuario }) => {
  const queryParams = new URLSearchParams({ ipUsuario }).toString()

  return putJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features.services ? 'compra-agil-adjuntos' : 'compra-agil'
    }/comprador/eliminar/${fileId}?${queryParams}`
  )
})

/**
 * Uploads the given a file, seller.
 */
export const uploadFileSeller = factoryService(({ file, quoteCode, ipUsuario }) => {
  const body = { file }
  const queryParams = new URLSearchParams({ ipUsuario }).toString()

  return postFormRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.attach'] ? 'compra-agil-adjuntos' : 'compra-agil'
    }/proveedor/solicitud/${quoteCode}/cotizacion/adjuntar?${queryParams}`,
    { body }
  )
})

/**
 * Get seller attached files, seller.
 */
export const getAttachedFilesSeller = factoryService(({ quoteCode }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.attach'] ? 'compra-agil-adjuntos' : 'compra-agil'
    }/proveedor/solicitud/${quoteCode}/cotizacion/adjuntos`
  )
})

/**
 * Get download file, seller.
 */
export const getDowloadFileSeller = factoryService(({ fileId }) => {
  return getFileRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.attach'] ? 'compra-agil-adjuntos' : 'compra-agil'
    }/proveedor/cotizacion/descargarAdjunto/${fileId}`
  )
})

/**
 * Delete a file by the given identifier, seller.
 */
export const deleteFileSeller = factoryService(({ fileId, ipUsuario }) => {
  const queryParams = new URLSearchParams({ ipUsuario }).toString()

  return putJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.attach'] ? 'compra-agil-adjuntos' : 'compra-agil'
    }/proveedor/cotizacion/adjuntos/${fileId}/eliminar?${queryParams}`
  )
})
